import React, { useState } from 'react'
import { Card, Row, Space, Input } from 'antd'
import _, { isEmpty } from 'lodash'
import { MaterialItem, TypeItem } from '../../../shared.style'
import { useDeepEffect } from '../../../utils/hooks'
import { ButtonEx } from '../../HeroLocations/index.style'
import CardComponent from '../../../components/CardComponent'
import { AddDiv } from '../index.style'

const AddMaterial = (props) => {
  const { materials, onChangePage, myProducts, setMyProducts } = props
  const [typeId, setTypeId] = useState([])
  const [stateList, setStateList] = useState([])

  useDeepEffect(() => {
    if (!isEmpty(materials)) {
      setStateList(materials)
    }
  }, [materials])

  useDeepEffect(() => {
    for (const myProduct of myProducts) {
      if (!_.isEmpty(myProduct.products)) {
        setTypeId((prevState) => {
          prevState.push(myProduct.categoryId)
          return [...prevState]
        })
      }
    }
  }, [myProducts])

  useDeepEffect(() => {
    setMyProducts((prevState) => {
      prevState.forEach((item) => {
        if (item.id === typeId[0]) {
          if (!_.isEmpty(item.products)) {
            item.products.forEach((product) => {
              materials.forEach((material) => {
                if (product.material.id !== material.id) {
                  if (material.baseMaterial) {
                    item.products.push({
                      material: material,
                      minQuantity: 'NO_LIMIT'
                    })
                  }
                }
              })
            })
          } else {
            const arr = []
            materials.forEach((material) => {
              if (material.baseMaterial) {
                arr.push({
                  material: material,
                  minQuantity: 'NO_LIMIT'
                })
              }
            })
            item.products = arr
          }
        }
      })

      return [...prevState]
    })
  }, [])

  function onChange(id) {
    const added = _.some(typeId, (item) => {
      return item === id
    })

    if (added) {
      setTypeId((prevState) => {
        const arr = prevState.filter((item) => item !== id)
        return arr
      })
    } else {
      setTypeId((prevState) => {
        prevState.push(id)
        return [...prevState]
      })
    }

    setMyProducts((prevState) => {
      prevState.forEach((item) => {
        if (item.categoryId === id) {
          if (!_.isEmpty(item.products)) {
            if (!added) {
              item.materialList.forEach((material) => {
                if (material.baseMaterial) {
                  item.products.push({
                    material: material,
                    minQuantity: 'NO_LIMIT'
                  })
                }
              })
            } else {
              item.products = item.products.filter((product) => {
                return !product.material.baseMaterial
              })
            }
          } else {
            const arr = []
            item.materialList.forEach((material) => {
              if (material.baseMaterial) {
                arr.push({
                  material: material,
                  minQuantity: 'NO_LIMIT'
                })
              }
            })
            item.products = arr
          }
        }
      })

      return [...prevState]
    })

    setStateList((prevState) => {
      prevState.forEach((item) => {
        if (item.categoryId === id) {
          if (!_.isEmpty(item.products)) {
            item.products = item.products.filter((product) => {
              return product.baseMaterial
            })
          } else {
            const arr = []
            item.materialList.forEach((material) => {
              if (material.baseMaterial) {
                arr.push({
                  material: material,
                  minQuantity: 'NO_LIMIT'
                })
              }
            })
            item.products = arr
          }
        }
      })

      return [...prevState]
    })
  }

  function onClickItem(material, category) {
    let added = false
    myProducts.forEach((item) => {
      item.products.forEach((product) => {
        if (product.material.id === material.id) {
          added = true
        }
      })
    })

    if (added) {
      setMyProducts((prevState) => {
        prevState.forEach((item) => {
          _.remove(item.products, (product) => {
            return product.material.id === material.id
          })
        })

        return [...prevState]
      })
    } else {
      setMyProducts((prevState) => {
        prevState.forEach((item) => {
          if (category.categoryId === item.categoryId) {
            item.products.push({
              material: material,
              minQuantity: 'NO_LIMIT'
            })
          }
        })

        return [...prevState]
      })
    }
  }

  function onSearch(e) {
    const { value } = e.target

    if (value) {
      setStateList((prevState) => {
        myProducts.forEach((product) => {
          prevState.forEach((item) => {
            if (product.id === item.id) {
              const arr = _.filter(product.materialList, (material) => {
                return material.name.includes(value)
              })

              item.materialList = arr
            }
          })
        })

        return [...prevState]
      })
    } else {
      setStateList((prevState) => {
        myProducts.forEach((product) => {
          prevState.forEach((item) => {
            if (product.id === item.id) {
              item.materialList = product.materialList
            }
          })
        })

        return [...prevState]
      })
    }
  }

  const renderItemActive = (item) => {
    let active = false

    if (!_.isEmpty(myProducts)) {
      myProducts.forEach((material) => {
        material.products.forEach((product) => {
          if (product.material.id === item.id) {
            active = true
          }
        })
      })
    }

    return active
  }

  const renderTypeItemActive = (id) => {
    let active = false

    if (!_.isEmpty(typeId)) {
      typeId.forEach((item) => {
        if (item === id) {
          active = true
        }
      })
    }

    return active
  }

  const getLengthProducts = () => {
    let length = 0

    myProducts.forEach((item) => {
      length += item.products.length
    })

    return length
  }

  const onSetStateList = () => {
    setStateList((prevState) => {
      myProducts.forEach((product) => {
        prevState.forEach((item) => {
          if (product.id === item.id) {
            item.materialList = product.materialList
          }
        })
      })

      return [...prevState]
    })
  }

  const onBack = async () => {
    await onSetStateList()
    await onChangePage('list')
  }

  const onPickMaterial = async () => {
    await onSetStateList()
    await onChangePage('edit')
  }

  return (
    <AddDiv>
      <CardComponent>
        <Space size="small">
          <Input.Search placeholder="ค้นหา" onChange={onSearch} />
          <span>วัสดุที่คุณเลือก {getLengthProducts()} รายการ</span>
        </Space>
        <Row>
          <span style={{ fontSize: 18 }}>เลือกวัสดุพื้นฐานในหมวด</span>
        </Row>
        <Row>
          {!_.isEmpty(materials) &&
            materials.map((item, index) => {
              return (
                <TypeItem
                  key={index}
                  onClick={() => onChange(item.categoryId)}
                  active={renderTypeItemActive(item.categoryId)}>
                  {item.categoryName}
                </TypeItem>
              )
            })}
        </Row>
        <Card style={{ marginTop: 10, height: 450, overflowY: 'scroll' }}>
          {!_.isEmpty(stateList) &&
            stateList.map((item, index) => {
              return (
                <div key={index}>
                  <Row>
                    <Row style={{ width: '100%' }}>
                      <span style={{ color: 'green', fontSize: 18 }}>
                        {item.categoryName}
                      </span>
                    </Row>
                    <Row>
                      {item.materialList.map((material, idx) => {
                        return (
                          <MaterialItem
                            key={idx}
                            active={renderItemActive(material)}
                            onClick={() => onClickItem(material, item)}>
                            {material.name}
                          </MaterialItem>
                        )
                      })}
                    </Row>
                  </Row>
                </div>
              )
            })}
        </Card>
      </CardComponent>
      <Row justify="center">
        <Space>
          <ButtonEx color="#707070" type="primary" onClick={() => onBack()}>
            ย้อนกลับ
          </ButtonEx>
          <ButtonEx
            color="#6ebf4b"
            type="primary"
            onClick={() => onPickMaterial()}>
            เลือกวัสดุ
          </ButtonEx>
        </Space>
      </Row>
    </AddDiv>
  )
}

export default AddMaterial



// WEBPACK FOOTER //
// ./src/pages/AccountProduct/AddMaterial/index.js